<template>
  <div class="eds-comp-flow-file">
    <div v-for="(file, index) in topFiles" :key="index" class="flow_file"
      :class="{ 'is-current-file': currentFileId === file.id, }" @click="(e) => onFlowFileClick(file, e)">
      <template v-if="isCompressedFile(file)">
        <v-expansion-panel class="no-border">
          <v-expansion-panel-content>
            <template v-slot:header>
              <div class="flow_file_infos">
                <edsFileIcon :fileName="file.name" />
                <div class="flow_file_info">{{ file.name }}</div>
                <div class="flow_file_info--size" v-if="file.size / 1024 > 1024">
                  {{ (file.size / 1024 / 1024).toFixed(0) }}M
                </div>
                <div class="flow_file_info--size" v-else>
                  {{ (file.size / 1024).toFixed(0) }}KB
                </div>
              </div>
            </template>
            <v-list>
              <v-list-tile v-for="child in file.children" :key="child.id">
                <div class="flow_file_infos">
                  <edsFileIcon :fileName="child.name" />
                  <div class="flow_file_info">{{ child.name }}</div>
                  <div class="flow_file_info--size" v-if="child.size / 1024 > 1024">
                    {{ (child.size / 1024 / 1024).toFixed(0) }}M
                  </div>
                  <div class="flow_file_info--size" v-else>
                    {{ (child.size / 1024).toFixed(0) }}KB
                  </div>
                </div>
                <div class="flow_file_download">
                  <v-btn v-if="allowDownload" :disabled="disabledDownload(child)" round small
                    @click.stop="onOpenFile(child)">{{
                      $t('预览') }}</v-btn>
                </div>
              </v-list-tile>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
      <template v-else>
        <div class="flow_file_infos">
          <edsFileIcon :fileName="file.name" />
          <div class="flow_file_info">{{ file.name }}</div>
          <div class="flow_file_info--size" v-if="file.size / 1024 > 1024">
            {{ (file.size / 1024 / 1024).toFixed(0) }}M
          </div>
          <div class="flow_file_info--size" v-else>
            {{ (file.size / 1024).toFixed(0) }}KB
          </div>
        </div>
        <div class="flow_file_download">
          <v-btn v-if="allowDownload" :disabled="disabledDownload(file)" round small @click.stop="onOpenFile(file)">{{
            $t('预览') }}</v-btn>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
import edsFileIcon from './edsFileIcon'
import msgbus from '../msgBus'
import functions from '../functions'
import isTest from '../util/urltest'
import { URLS } from '../util/urls'
import devHelper from '../util/devHelper'


export default {
  name: 'eDSCompFlowFile',
  components: {
    edsFileIcon,
  },
  props: {
    flowInfo: { // 流程信息
      type: Object,
      defalut: null
    },
    flowFiles: { // 流程文件集
      type: Array,
      defalut: []
    },
    allowDownload: { // 是否允许预览
      type: Boolean,
      default: false
    },
    flowTid: { // 当前流程所属租户tid
      type: String,
      default: '',
    },
    flowTname: { // 当前流程所属租户tname
      type: String,
      default: '',
    }
  },
  data() {
    return {
      currentFileId: null, // 当前文件Id(可换行显示文件名)
      userID: '', // 登录账户在当前租户的用户ID
    }
  },
  computed: {
    topFiles() {
      return this.flowFiles.filter(item => item.archiveID == '') // 顶层流程文件集
    },
  },
  methods: {
    // 判断是否是压缩文件
    isCompressedFile(file) {
      let compressedExt = ['.zip', '.rar', '.7z']
      // 获取文件后缀
      let fileExt = file.name
        .substring(file.name.lastIndexOf('.'))
        .toLowerCase()
      let index = compressedExt.findIndex(ext => ext == fileExt)
      if (index > -1) {
        file['children'] = this.getAllChildFiles(file)
        return true
      }
      return false
    },

    // 获取压缩包下所有文件集（打平）
    getAllChildFiles(file) {
      let allChild = []
      this.getChildFiles(file, allChild)
      return allChild
    },

    getChildFiles(file, childFiles) {
      let children = this.flowFiles.filter(item => item.archiveID == file.id) // 压缩包内所有文件集（打平）
      children.forEach(child => {
        if (!this.isCompressedFile(child)) {
          childFiles.push(child)
        } else {
          this.getChildFiles(child, childFiles)
        }
      })
    },


    onFlowFileClick(file, e) {
      if (this.currentFileId === file.id) {
        this.currentFileId = ''
      } else {
        this.currentFileId = file.id
      }
    },

    // 能否下载（根据后缀，文件大小，判断能否下载）
    disabledDownload(file) {
      let disabledDownload = false
      // 大小限制（100M/ 1,048,576）
      if (file.size / 1024 / 1024 > 100) {
        disabledDownload = true
      } else {
        // 后缀暂定： doc docx ppt pptx xls xlsx txt pdf epub dwg
        let canExts = []
        if (msgbus.vm.getPlatform() == 'Android') {
          canExts.push(...[
            'doc',
            'docx',
            'ppt',
            'pptx',
            'xls',
            'xlsx',
            'txt',
            'pdf',
            'epub',
            'dwg',
          ])
        } else if (msgbus.vm.getPlatform() == 'iOS') {
          canExts.push(...[
            'doc',
            'docx',
            'ppt',
            'pptx',
            'xls',
            'xlsx',
            'txt',
            'pdf',
            'epub',
          ])
        } else {
          if (isTest) {
            canExts.push(...[
              'doc',
              'docx',
              'ppt',
              'pptx',
              'xls',
              'xlsx',
              'txt',
              'pdf',
              'epub',
              'dwg',
            ])
          }
        }
        let fileExtension = file.name
          .substring(file.name.lastIndexOf('.') + 1)
          .toLowerCase()
        let filter = canExts.filter((canExt) => canExt === fileExtension)
        if (filter.length == 0) {
          disabledDownload = true
        }
      }
      return disabledDownload
    },

    // 预览文件
    onOpenFile(file) {
      if (msgbus.vm.getPlatform() == 'browser') {
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: this.$t('预览仅支持Android和IOS系统'),
            visible: true,
          },
        })
        if (sessionStorage.__debug === 'true') {
          msgbus.vm.setRequestStorage({
            value: {
              visible: true,
              callback: (granted) => {
                console.debug(granted)
              }
            }
          })
        }

        // ----------------------以下用于测试--------------------------------
        // 置正在下载标记true
        // msgbus.vm.setIsDownloading({ value: true })

        // // 根据流程编号，请求流程源文件
        // let data = {
        //   fileIDs: [file.id]
        // }
        // msgbus.vm.requestFlowSourceFiles({
        //   authorization: {
        //     Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        //   },
        //   tid: this.flowTid,
        //   flowID: this.flowInfo.id,
        //   data: data,
        //   vm: msgbus.vm,
        // })
        //   .then(
        //     (resp) => {
        //       console.log('requestFlowSourceFiles', resp)
        //       if (resp.data.needPrepare) {
        //         // 每隔一段时间调用checkPrepareStatus()函数
        //         this.intervalId = setInterval(() => { this.testCheckPrepareStatus(resp.data) }, 5000) // 时间间隔为5秒
        //       } else {
        //         this.testDownloadFile(resp.data.url, resp.data.requestFileName)
        //         // 置下载标记false
        //         msgbus.vm.setIsDownloading({ value: false })
        //       }
        //     },
        //     () => {
        //       // 置下载标记false
        //       msgbus.vm.setIsDownloading({ value: false })
        //     }
        //   )
        // ----------------------以上用于测试--------------------------------

      } else {
        // 置正在下载标记true
        msgbus.vm.setIsDownloading({ value: true })

        // 根据流程编号，请求流程源文件
        let data = {
          fileIDs: [file.id]
        }
        msgbus.vm.requestFlowSourceFiles({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          tid: this.flowTid,
          flowID: this.flowInfo.id,
          data: data,
          vm: msgbus.vm,
        })
          .then(
            (resp) => {
              if (resp.data.needPrepare) {
                // 每隔一段时间调用checkPrepareStatus()函数
                this.intervalId = setInterval(() => { this.checkPrepareStatus(resp.data, file) }, 5000) // 时间间隔为5秒
              } else {
                // 预览文件
                this.openFile(file, resp.data.url)
              }
            },
            () => {
              // 置下载标记
              msgbus.vm.setIsDownloading({ value: false })
            }
          )
      }
    },
    // 检查文件准备状态
    checkPrepareStatus(download, file) {
      let params = {
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: this.flowTid,
        downloadID: download.id,
        vm: msgbus.vm,
      }
      msgbus.vm.checkPreparedDownloadFile(params).then(
        (resp) => {
          if (resp.data.ready) {
            // 停止轮询
            clearInterval(this.intervalId)
            // 置下载标记
            msgbus.vm.setIsDownloading({ value: false })
            // 预览文件
            this.openFile(file, download.url)
          }
          if (resp.data.error) {
            // 停止轮询
            clearInterval(this.intervalId)
            // 置下载标记
            msgbus.vm.setIsDownloading({ value: false })
            msgbus.vm.setSnackBar({
              value: {
                color: 'error',
                text: this.$t('下载异常') + resp.data.errMsg,
                visible: true
              }
            })
          }
        },
        () => {
          // 停止轮询
          clearInterval(this.intervalId)
          // 置下载标记
          msgbus.vm.setIsDownloading({ value: false })
        })
    },
    // 预览文件
    openFile(file, url) {
      if (devHelper.isDevMode()) { // 判断是否开启了测试模式)
        alert('openFile')
      }
      file['url'] = url

      if (devHelper.isDevMode()) { // 判断是否开启了测试模式)
        alert(url)
      }

      var fileName = this.flowTid + '+' + file.id + '+' + file.name
      // 检查是否下载完成，若下载完成则直接打开文件
      functions.sqliteHelper.queryFile(1, fileName).then((resultSet) => {
        if (
          resultSet.rows.length > 0 &&
          resultSet.rows.item(0).downloadPer == 100
        ) {
          // 直接打开文件
          let fileInfo = {
            isFlowFile: resultSet.rows.item(0).isFlowFile, // 标识是否流程文件 1 是，0 不是
            fileWholeName: resultSet.rows.item(0).fileWholeName, // 路径+文件名
            fileName: resultSet.rows.item(0).fileName, // 文件名
            flowID: resultSet.rows.item(0).flowID, // 流程ID
            flowName: resultSet.rows.item(0).flowName, // 流程名称
            flowFileURL: resultSet.rows.item(0).flowFileURL, // 流程文件下载URL
            flowFileName: resultSet.rows.item(0).flowFileName, // 流程文件名
            encrypted: resultSet.rows.item(0).encrypted, // 文件是否加密
            key: resultSet.rows.item(0).key, // 打开加密文件所用的密钥
            userOID: resultSet.rows.item(0).userID, // 用户OID
            orgID: resultSet.rows.item(0).orgID, // 组织OID
            clID: resultSet.rows.item(0).clID, // 文件密级
            fileID: resultSet.rows.item(0).fileID, // 文件ID,
            tid: resultSet.rows.item(0).tid,
            tname: resultSet.rows.item(0).tname,
            downloadPer: resultSet.rows.item(0).downloadPer,
          }
          // 写Sqlite本地数据库打开文件信息
          functions.edsfileview.funcWriteSqlite(fileInfo)
          //打开文件
          functions.edsfileview.funcFileBrowsing(fileInfo)
        } else {
          // 下载并打开文件
          let fileInfo = {
            isFlowFile: 1,
            fileWholeName: '',
            fileName: fileName, // 文件名（物理文件名）
            flowID: this.flowInfo.id, // 流程ID
            flowName: this.flowInfo.title, // 流程名称
            flowFileURL: file.url, // 流程文件下载URL
            flowFileName: file.name, // 流程文件名
            tid: this.flowTid,
            tname: this.flowTname,
            fileID: file.id,
          }
          functions.edsdownloadfileHelper.funcEdsDownloadFile(
            1, // 1 标识下载完成后打开文件
            fileInfo
          )
        }
      })
    },

    // EDS16浏览器端 测试接口：检查文件准备状态
    testCheckPrepareStatus(download) {
      let params = {
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: this.flowTid,
        downloadID: download.id,
        vm: msgbus.vm,
      }
      msgbus.vm.checkPreparedDownloadFile(params).then(
        (resp) => {
          if (resp.data.ready) {
            // 停止轮询
            clearInterval(this.intervalId)
            // 置下载标记
            msgbus.vm.setIsDownloading({ value: false })
            // 开始下载
            this.testDownloadFile(download.url, download.requestFileName)
          }
          if (resp.data.error) {
            // 停止轮询
            clearInterval(this.intervalId)
            // 置下载标记
            msgbus.vm.setIsDownloading({ value: false })
            msgbus.vm.setSnackBar({
              value: {
                color: 'error',
                text: this.$t('下载异常') + resp.data.errMsg,
                visible: true
              }
            })
          }
        },
        () => {
          // 停止轮询
          clearInterval(this.intervalId)
          // 置下载标记
          msgbus.vm.setIsDownloading({ value: false })
        })
    },

    // EDS16浏览器端 测试接口：直接下载文件
    testDownloadFile(url, fileName) {
      try {
        const a = document.createElement('a')
        a.href = url
        a.download = fileName
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (error) {
        msgbus.vm.setSnackBar({
          value: {
            color: 'error',
            text: this.$t('文件下载失败'),
            visible: true
          }
        })
      }
    },

  },
  created() {
    console.log('调试代码')
  },
  mounted() { }
}
</script>


<style lang="scss">
.eds-comp-flow-file {
  .flow_file {
    display: flex;
    background: rgba(243, 243, 243, 1);
    border-radius: 4px;

    &+.flow_file {
      margin-top: 8px;
    }

    .flow_file_infos {
      flex: 1 1 auto;
      overflow: hidden;
      padding: 4px 0 0 46px;
      position: relative;

      .eds-file-icon {
        position: absolute;
        left: 10px;
        top: 10px;
      }

      .flow_file_info {
        color: rgba(56, 56, 56, 1);
        overflow: hidden; // 溢出隐藏
        text-overflow: ellipsis; // 规定文本不进行换行
        white-space: nowrap; // 当对象内文本溢出时，显示省略标记(…)
      }

      .flow_file_info--size {
        color: rgba(138, 138, 138, 1);
        font-size: 12px;
        overflow: hidden; // 溢出隐藏
        text-overflow: ellipsis; // 规定文本不进行换行
        white-space: nowrap; // 当对象内文本溢出时，显示省略标记(…)
      }
    }

    .flow_file_download {
      flex: none;

      & .v-btn {
        padding: 0 !important;
        margin-top: 10px;
        min-width: 50px;
        height: 21px;

        .v-btn__content {
          width: 40px;
        }
      }
    }

    &.is-current-file {
      &>.flow_file_infos {
        &>.flow_file_info {
          white-space: normal;
        }
      }
    }
  }

  .v-expansion-panel__header {
    padding-left: 0px !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    min-height: 0px !important;
    background: rgba(243, 243, 243, 1);
  }

  .v-list__tile {
    font-size: 14px !important;
  }

  .no-border {
    border: none !important;
    box-shadow: none !important;
  }
}
</style>